/* Golf Bros — self-insured free returns coverage (v3)
 * Replaces the FULL contents of assets/gb-returns-coverage.js
 *
 * v3 = v2 (section-swap drawer refresh) + cart writes routed through
 * window.fetch so the theme/app cart listeners see our mutations and
 * re-render immediately.
 */
(function () {
  var HANDLE = 'free-returns-coverage';
  var OPTOUT_KEY = 'gbCovOptOut';
  var ADDED_KEY = 'gbCovAdded';
  var nativeFetch = window.fetch.bind(window);
  var variantId = null;
  var syncing = false;

  function toJson(res) { return res.json(); }

  function getVariantId() {
    if (variantId) return Promise.resolve(variantId);
    return nativeFetch('/products/' + HANDLE + '.js')
      .then(toJson)
      .then(function (p) {
        variantId = p.variants[0].id;
        return variantId;
      })
      .catch(function () { return null; });
  }

  function getCart() {
    return nativeFetch('/cart.js').then(toJson);
  }

  // NOTE: goes through window.fetch on purpose, so the theme's own
  // fetch listeners see the mutation and re-render the drawer.
  function cartPost(path, body) {
    return window.fetch(path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function getSectionRenderId() {
    var el = document.getElementById('cart-drawer');
    var wrap = el && el.closest('[id^="shopify-section-"]');
    return wrap ? wrap.id.replace('shopify-section-', '') : null;
  }

  function refreshDrawer() {
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', { bubbles: true })
    );
    var sid = getSectionRenderId();
    if (!sid) return;
    nativeFetch('/?sections=' + encodeURIComponent(sid))
      .then(toJson)
      .then(function (sections) {
        var html = sections && sections[sid];
        if (!html) return;
        var holder = document.createElement('div');
        holder.innerHTML = html;
        var fresh = holder.querySelector('#cart-drawer');
        var existing = document.getElementById('cart-drawer');
        if (!fresh || !existing) return;
        if (existing.hasAttribute('open')) fresh.setAttribute('open', '');
        if (existing.getAttribute('class')) fresh.setAttribute('class', existing.getAttribute('class'));
        existing.replaceWith(fresh);
      })
      .catch(function () {});
  }

  function sync() {
    if (syncing) return;
    syncing = true;
    getVariantId().then(function (vid) {
      if (!vid) { syncing = false; return; }
      getCart().then(function (cart) {
        var covLine = null;
        var realCount = 0;
        cart.items.forEach(function (i) {
          if (i.variant_id === vid) { covLine = i; }
          else { realCount += i.quantity; }
        });

        function done(changed) {
          syncing = false;
          if (changed) refreshDrawer();
        }

        if (covLine && realCount === 0) {
          cartPost('/cart/change.js', { id: covLine.key, quantity: 0 }).then(function () {
            sessionStorage.removeItem(ADDED_KEY);
            done(true);
          });
        } else if (covLine && covLine.quantity > 1) {
          cartPost('/cart/change.js', { id: covLine.key, quantity: 1 }).then(function () {
            done(true);
          });
        } else if (!covLine && realCount > 0) {
          if (sessionStorage.getItem(ADDED_KEY) === '1') {
            sessionStorage.setItem(OPTOUT_KEY, '1');
            sessionStorage.removeItem(ADDED_KEY);
            done(false);
          } else if (sessionStorage.getItem(OPTOUT_KEY) !== '1') {
            cartPost('/cart/add.js', { id: vid, quantity: 1 }).then(function () {
              sessionStorage.setItem(ADDED_KEY, '1');
              done(true);
            });
          } else {
            done(false);
          }
        } else {
          done(false);
        }
      }).catch(function () { syncing = false; });
    });
  }

  window.GBCoverage = {
    toggle: function (on) {
      getVariantId().then(function (vid) {
        if (!vid) return;
        if (on) {
          sessionStorage.removeItem(OPTOUT_KEY);
          cartPost('/cart/add.js', { id: vid, quantity: 1 }).then(function () {
            sessionStorage.setItem(ADDED_KEY, '1');
            refreshDrawer();
          });
        } else {
          sessionStorage.setItem(OPTOUT_KEY, '1');
          sessionStorage.removeItem(ADDED_KEY);
          getCart().then(function (cart) {
            var line = null;
            cart.items.forEach(function (i) {
              if (i.variant_id === vid) line = i;
            });
            if (line) {
              cartPost('/cart/change.js', { id: line.key, quantity: 0 }).then(refreshDrawer);
            }
          });
        }
      });
    }
  };

  window.fetch = function () {
    var args = arguments;
    var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    return nativeFetch.apply(window, args).then(function (res) {
      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        setTimeout(sync, 100);
      }
      return res;
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();